import "./modal.scss";

import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";

const ModalCheckboxGrid = props => {
  return <div className={`modalCheckboxGrid col${props.columns ? props.columns : 1}`}>{props.children}</div>;
};

ModalCheckboxGrid.propTypes = {
  columns: PropTypes.number,
  children: PropTypeShapes.elementOrArrayOrList
};

export default ModalCheckboxGrid;
